<script>
import {mapActions, mapMutations, mapState} from "vuex";
import AmsuScholarshipCard from "../../Cards/AmsuScholarshipCard.vue";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'scholarship_comment/getPayloadComment',
  mutationType: 'scholarship_comment/updatePayloadComment',
});

export default {
  name: "TheMeetingCommentForStatementDialog",
  components: {AmsuScholarshipCard},

  data() {
    return {
      textAreaRules: [
        v => !!v || "Обязательно к заполнению"
      ]
    };
  },

  computed: {
    ...mapState({
      dialogComment: state => state.scholarship_comment.dialogComment,
      statement: state => state.scholarship_competition.statement,
      payloadComment: state => state.scholarship_comment.payloadComment,
    }),

    ...mapFields([
      "comment",
      "comment_type"
    ]),

    achievement() {
      if (_.isEmpty(this.statement)) return {};
      return _.find(this.statement.achievements, achievement => achievement.id === this.payloadComment.prtf_achievement_id);
    },

    isAchievementCommentPresent() {
      if (_.isEmpty(this.achievement)) return false;
      return !_.isNil(this.achievement.comments) && !_.isEmpty(this.achievement.comments);
    },
  },

  methods: {
    ...mapMutations({
      setCommentText: "scholarship_comment/setCommentText"
    }),

    ...mapActions({
      closeDialog: "scholarship_comment/closeDialog",
      createComment: "scholarship_comment/createComment",

      getStatement: 'scholarship_competition/getStatement',
    }),

    async deleteAchievement() {
      if (this.$refs["form-comment"].validate()) {
        this.comment_type = "delete_achievement"
        await this.createComment();
        await this.getStatement(this.statement.id);
      }
    },

  },
}
</script>

<template>
  <v-dialog
    :value="dialogComment"
    persistent
    max-width="max(40vw, 600px)"
    content-class="rounded-xl"
  >
    <amsu-scholarship-card>
      <v-card-title>
        Комментарий к удаляемому достижению
      </v-card-title>
      <v-divider/>
      <v-card-text class="mt-2">
        <v-form
          ref="form-comment"
        >
          <v-textarea
            v-model="comment"
            outlined
            placeholder="Напишите комментарий, он должен быть информативным и понятным."
            class="rounded-xl"
            color="teal darken-3"
            :rules="textAreaRules"
          >
          </v-textarea>
        </v-form>
      </v-card-text>

      <v-card-text>
        Внимание, начнется голосование за удаление достижения из заявления!
      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="teal darken-3"
          class="white--text rounded-xl"
          outlined
          @click="closeDialog"
        >
          Закрыть
        </v-btn>
        <v-card-text v-if="isAchievementCommentPresent">
          <v-icon small left color="warning">fa-exclamation</v-icon> Запрос на изменение уже существует
        </v-card-text>
        <v-btn
          v-else
          color="teal darken-3"
          class="white--text rounded-xl"
          @click="deleteAchievement"
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </amsu-scholarship-card>
  </v-dialog>
</template>

<style scoped>

</style>